import React from "react";

const InputWithIcon = ({
  id,
  title = "",
  wrapperClassName = "",
  leftIcon,
  leftIconClassName = "",
  type = "text",
  placeholder = "",
  containerClassName = "",
  inputClassName = "",
  rightIcon,
  rightIconClassName = "",
  labelClassName = "",
  rightIconHandler,
  rightIconStyle,
  required = false,
  disabled = false,
  value,
  onChange,
  error = "",
  min = "0",
  name,
  fullEventData = false
}) => {
  return (
    <div className={`${wrapperClassName}`}>
      {title ? (
        <label
          htmlFor={id}
          className={`font-size-small text-[var(--blackColor)] ${labelClassName}`}
        >
          {title}
          {required ? <span className="text-[#e55353]"> *</span> : null}
        </label>
      ) : null}

      <div className={`input-container mt-2 ${containerClassName}`}>
        {leftIcon ? (
          <img
            src={leftIcon}
            className={`input-icon ${leftIconClassName}`}
            alt="input icon left"
          />
        ) : null}
        <input
          type={type}
          placeholder={placeholder}
          className={`input-field font-size-medium ${inputClassName}`}
          disabled={disabled}
          value={value}
          onChange={(e) => {
            fullEventData ? onChange(e) : onChange(e.target.value);
          }}
          name={name}
          min={min}
        />
        {rightIcon ? (
          <img
            src={rightIcon}
            className={`input-icon-right ${rightIconClassName}`}
            alt="input icon right"
            onClick={rightIconHandler}
            style={rightIconStyle}
          />
        ) : null}
      </div>
      {error ? (
        <div className={`font-size-small text-[var(--textRed)] mt-2`}>
          {error}
        </div>
      ) : null}
    </div>
  );
};

export default InputWithIcon;
